class Sticky {
    constructor() {
        let elements = [];
        document.querySelectorAll(".fixed-bar").forEach(el => {
            elements.push([el, el.offsetTop])
        })
        this.init(elements);
    }

    init(elements) {
        window.onscroll = function () {
            elements.forEach(el => {
                if (window.pageYOffset - 620 > el[1]) {
                    el[0].classList.add("sticky");
                } else {
                    el[0].classList.remove("sticky");
                }
            })
        };
    }
}

export default Sticky
